import { useQuery } from '@tanstack/react-query';
import { apiUrlGenerator } from 'infrastructure/hooks/use-api';
import dataService from 'services/dataService';

import type { IGetProviderStatisticsResponse } from 'components/organisms/provider-dashboard';

export interface IGetProviderStatisticsFilters {
  startDate: string;
  endDate: string;
  clinicGuid?: string[];
  parentClinicGuid?: string[];
  providerGuid?: string;
  page: number;
  pageSize: number;
}

const url = 'core-2/provider-dashboard/provider-details';

export const getProviderStatisticsQueryKey = (
  filters: IGetProviderStatisticsFilters,
) => [url, filters] as const;

const queryFn = async (filters: IGetProviderStatisticsFilters) => {
  const { data, error } =
    await dataService.getList<IGetProviderStatisticsResponse>(
      apiUrlGenerator(url, filters),
    );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useGetProviderStatistics = (
  filters: IGetProviderStatisticsFilters,
  enabled = true,
) => {
  const queryKey = getProviderStatisticsQueryKey(filters);

  const { data, isLoading, isFetching } = useQuery<
    IGetProviderStatisticsResponse | undefined,
    string | undefined
  >({
    queryKey,
    queryFn: async () => queryFn(filters),
    keepPreviousData: true,
    enabled,
  });

  return {
    providerStatistics: data,
    isLoading,
    isFetching,
  };
};
